import { render, staticRenderFns } from "./LayoutToggle.vue?vue&type=template&id=8228ff20&"
import script from "./LayoutToggle.vue?vue&type=script&lang=js&"
export * from "./LayoutToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports